module.exports = __webpack_public_path__ + "static/img/7.bc68a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Multiriesgo-corporativo/7.png
// module id = XruV
// module chunks = 0